exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cat-filter[data-v-7108c484] {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.041667rem;\n}\n.cat-filter button[data-v-7108c484] {\n  padding: 0.03125rem 0.083333rem;\n  border: 0.005208rem solid #d5dee6;\n  border-radius: 0.104167rem;\n  background: #fff;\n  color: #3D4D61;\n  font-size: 0.09375rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.cat-filter button[data-v-7108c484]:hover {\n  border-color: #1668f4;\n  color: #1668f4;\n}\n.cat-filter button.is-active[data-v-7108c484] {\n  background: #1668f4;\n  border-color: #1668f4;\n  color: #fff;\n  font-weight: 500;\n}", ""]);

// exports
